import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Datagrid from "../Components/Datagrid";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import toolbar from "../Config/toolbarConfig";
import useTitle from "../Hooks/useTitle";
import { useTranslation } from "react-i18next";

const TransactionDetailPage = () => {
  const { userId } = useParams();

  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);

  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Transaction Details")} | Netileti`);

  // const convertTimestamp = (unixTimestamp) => {
  //   const date = new Date(unixTimestamp * 1000);
  //   return date.toLocaleString();
  // };

  useEffect(() => {
    const fetchUserTransactions = async () => {
      setUrl(`${baseUrl}/credits/GetTransactions/${userId}`);
      setFrom("TransactionDetails");
    };

    fetchUserTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "type",
      headerText: t("Transaction Type"),
      allowEditing: false,
    },
    {
      field: "creditAmount",
      headerText: t("Amount"),
      allowEditing: false,
    },
    {
      field: "timestamp",
      headerText: t("Time"),
      allowEditing: false,
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            url,
            toolbar: toolbar("EXPORT"),
            setStatus,
            from,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default TransactionDetailPage;
